import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-analog-digital-popup',
  templateUrl: './analog-digital-popup.component.html'
})
export class AnalogDigitalComponent implements OnInit {

  // windowheight: any;
  // divHeight: number;
  AnalogDigitalForm!: FormGroup;
  displayMessage: any;
  msg: any;
  flag: any;
  msgtype: any;
  flagtype: any;

  constructor(private form: FormBuilder, public dialogRef: MatDialogRef<AnalogDigitalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
    // this.AnalogDigitalForm = this.form.group({
    //   metertype: ['Analog', [Validators.required]]
    // });
  }

  // SendDeviceType() {
  //   let obj =
  //   {
  //     metertype: this.AnalogDigitalForm.value.metertype
  //   }
  //   this.dialogRef.close(obj);
  // }

  Metertype(eve: any) {
    console.log(eve);
    let obj =
    {
      metertype: eve
    }
    this.dialogRef.close(obj);


  }
  Close() {
    this.dialogRef.close();
  }

}
